<template>
  <vb-datepicker
    ref="datepicker"
    :value="value"
    type="month"
    :placeholder="placeholder"
    @blur="onBlur"
    @month-selected="onMonthSelected"
  />
</template>

<script>
export default {
  props: {
    value: {},
    placeholder: { type: String, default: '' },
  },
  computed: {
    val() {
      return this.$refs.datepicker.val
    },
  },
  methods: {
    onBlur() {
      this.$emit('blur', this.val)
      this.$emit('input', this.val)
    },
    onMonthSelected(date) {
      this.$emit('input', this.val)
      this.$emit('month-selected', this.val)
      this.$refs.datepicker.close()
    },
  },
}
</script>
